import { NgModule } from '@angular/core';
import { HandleErrorModule } from './components/handle-errors/handle-errors.module';
import { OutOfTimeModule } from './components/out-office/out-office.module';
import { OverlayModule } from './components/overlay/overlay.module';
import { InterceptorsModule } from './interceptors/interceptors.module';
import { DefaultModule } from './layouts/default/default.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PrivacyPoliciesModule } from './layouts/privacy-policies/privacy-policies.module';

@NgModule({
  exports: [
    DefaultModule,
    OverlayModule,
    HandleErrorModule,
    OutOfTimeModule,
    InterceptorsModule,
    PrivacyPoliciesModule,
    BrowserAnimationsModule,
  ],
  declarations: [],
})
export class CoreModule {}
